module.exports = __webpack_public_path__ + "static/media/anushka_tadphale.3ca10eaa.jpg";